module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_trouble01-c63f67d7a5e94a84670dd92e68f6bdb4.png";